'use client';

import { ReactElement } from 'react';
import { GTM_NO_SCRIPT_URL } from './constants';

type Props = {
  gtmId: string;
  url?: string;
};

export const GtmNoscript = ({ gtmId, url = GTM_NO_SCRIPT_URL }: Props): ReactElement => {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: `<noscript><iframe src="${url}?id=${gtmId}" height="0" width="0" style="display: none; visibility: hidden"></iframe></noscript>`,
      }}
    />
  );
};
